export const NEW_STATUS = 'Новый'
export const IN_PROGRESS_STATUS = 'В работе'
export const NEED_REVISION_STATUS = 'Требуется доработка'
export const EXECUTED_STATUS = 'Завершен'
export const DECLINED_STATUS = 'Отказан'
export const POSTPONED_STATUS = 'Отложен'
